import { appRoute } from "@/components/routes/app-route";
import { DEFAULT_TRANSPORT_TYPE } from "@/config/otp";

export function useAppTransportType() {
    const type = appRoute.useSearch({ select: s => s.data?.transportType });

    return !type ? DEFAULT_TRANSPORT_TYPE : type
}
